import { Provider } from '@angular/core';

import { AutocompleteService } from '../Domain/Port/autocomplete.service';
import { GoogleAutocompleteService } from '../Infrastructure/Adapter/Google/Autocomplete/google-autocomplete.service';

/**
 * Function to provide the GeocodingService as an array of providers
 */
export const provideAutocompleteService = (): Provider[] => {
    return [
        {
            provide: AutocompleteService,
            useExisting: GoogleAutocompleteService
        }
    ];
};
